<template>
  <BliModal
    type="status"
    :active="showModal"
    :status="status"
    :width="size"
    @blur="$emit('closeModal')"
  >
    <BliModalHeader @close="$emit('closeModal')">
      <template #title>
        {{ title }}
      </template>
    </BliModalHeader>
    <BliModalBody>
      {{ description }}
    </BliModalBody>
    <BliModalFooter :long-action="isLongAction">
      <BliButton
        prominence="tertiary"
        color="common"
        @click="$emit('onTertiaryClick')"
      >
        {{ tertiaryButtonLabel }}
      </BliButton>
      <BliButton
        prominence="primary"
        color="common"
        @click="$emit('onPrimaryClick')"
      >
        {{ primaryButtonLabel }}
      </BliButton>
    </BliModalFooter>
  </BliModal>
</template>
<script src="./index.js" />
<style lang="scss" scoped>
      html:not([dark]) {
        @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
      }
      html[dark] {
        @import '@blibli/blue-design-tokens/dist/tokens-dark.scss';
      }
</style>
